module.exports = __webpack_public_path__ + "static/media/three-third.35a42de0.svg";